module.exports = __webpack_public_path__ + "img/3641988616201f83.png";